module.exports = __webpack_public_path__ + "static/ConveyorBeers2-52cb0ac25c32756414822a26df6d9063.png";